export const UserEditIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.875 16.5H4.94315C3.78412 16.5 2.86223 15.936 2.0345 15.1474C0.340025 13.5331 3.1221 12.243 4.18318 11.6112C6.09604 10.4722 8.40428 10.2088 10.5 10.8211"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.375 4.875C12.375 6.73896 10.864 8.25 9 8.25C7.13604 8.25 5.625 6.73896 5.625 4.875C5.625 3.01104 7.13604 1.5 9 1.5C10.864 1.5 12.375 3.01104 12.375 4.875Z"
      stroke="currentColor"
      strokeWidth="1.125"
    />
    <path
      d="M13.8249 10.3864C14.0764 10.1138 14.2021 9.97764 14.3357 9.89814C14.6581 9.70636 15.0552 9.70044 15.383 9.88239C15.5188 9.95784 15.6484 10.0903 15.9077 10.355C16.1669 10.6199 16.2965 10.7523 16.3704 10.8911C16.5485 11.2259 16.5427 11.6315 16.3549 11.9609C16.2772 12.0974 16.1438 12.2258 15.877 12.4828L12.7033 15.5396C12.1978 16.0265 11.9451 16.2699 11.6292 16.3933C11.3134 16.5167 10.966 16.5076 10.2715 16.4894L10.177 16.487C9.96561 16.4814 9.85994 16.4786 9.79844 16.4089C9.73701 16.3391 9.74541 16.2314 9.76214 16.0161L9.77129 15.8991C9.81854 15.293 9.84209 14.9899 9.96051 14.7174C10.0789 14.4449 10.283 14.2238 10.6914 13.7813L13.8249 10.3864Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
  </svg>
);
